import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export function Badge(props) {
  const $ = _c(11);
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M31.0222 0H0.982237C0.440976 0 0.00219727 0.43878 0.00219727 0.980041V38.5577C0.00219727 39.2496 0.699837 39.7237 1.34314 39.4689L15.3325 33.9278C15.5601 33.8377 15.8133 33.836 16.0421 33.9231L30.6734 39.4941C31.3149 39.7383 32.0022 39.2645 32.0022 38.5782V0.98004C32.0022 0.438779 31.5634 0 31.0222 0Z" fill="#218E50" />;
    t1 = <path d="M23.4444 7.66846H18.8939C18.7046 7.66846 18.55 7.82515 18.55 8.01883V13.0024L13.4511 7.81209C13.3597 7.71851 13.2379 7.66846 13.1095 7.66846H8.41316C8.22383 7.66846 8.06714 7.82515 8.06714 8.01883V23.3221C8.06714 23.5158 8.22383 23.6725 8.41316 23.6725H12.9637C13.1552 23.6725 13.3075 23.5158 13.3075 23.3221V18.3385L18.4064 23.5288C18.4956 23.6224 18.6197 23.6746 18.7481 23.6746H23.4444C23.6337 23.6746 23.7882 23.5179 23.7882 23.3243V18.3407V8.02101C23.7882 7.82732 23.6337 7.67063 23.4444 7.67063" fill="white" />;
    t2 = <path d="M0 27.1929V39.1273C0 39.5952 0.467889 39.9129 0.892254 39.7345L15.9278 33.8891L0 27.1929Z" fill="#00682C" />;
    t3 = <path d="M0 27.1929L14.1605 34.5524L15.9278 33.8891L0 27.1929Z" fill="#00482F" />;
    t4 = <path d="M31.0222 0H0.982237C0.440976 0 0.00219727 0.43878 0.00219727 0.980041V38.5577C0.00219727 39.2496 0.699837 39.7237 1.34314 39.4689L15.3325 33.9278C15.5601 33.8377 15.8133 33.836 16.0421 33.9231L30.6734 39.4941C31.3149 39.7383 32.0022 39.2645 32.0022 38.5782V0.98004C32.0022 0.438779 31.5634 0 31.0222 0Z" fill="url(#paint0_linear_20224_3999)" />;
    t5 = <path d="M23.4444 7.66846H18.8939C18.7046 7.66846 18.55 7.82515 18.55 8.01883V13.0024L13.4511 7.81209C13.3597 7.71851 13.2379 7.66846 13.1095 7.66846H8.41316C8.22383 7.66846 8.06714 7.82515 8.06714 8.01883V23.3221C8.06714 23.5158 8.22383 23.6725 8.41316 23.6725H12.9637C13.1552 23.6725 13.3075 23.5158 13.3075 23.3221V18.3385L18.4064 23.5288C18.4956 23.6224 18.6197 23.6746 18.7481 23.6746H23.4444C23.6337 23.6746 23.7882 23.5179 23.7882 23.3243V18.3407V8.02101C23.7882 7.82732 23.6337 7.67063 23.4444 7.67063" fill="white" />;
    t6 = <path d="M0 27.1929V39.1273C0 39.5952 0.467889 39.9129 0.892254 39.7345L15.9278 33.8891L0 27.1929Z" fill="#00682C" />;
    t7 = <path d="M0 27.1929L14.1605 34.5524L15.9278 33.8891L0 27.1929Z" fill="#00482F" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <defs><linearGradient id="paint0_linear_20224_3999" x1="3.56567" y1="3.11774" x2="34.3559" y2="28.7685" gradientUnits="userSpaceOnUse"><stop stopColor="#00682C" /><stop offset="1" stopColor="#2A9859" /></linearGradient></defs>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== props) {
    t9 = <svg width="32" height="40" viewBox="0 0 32 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}</svg>;
    $[9] = props;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  return t9;
}